/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import { useStateContext } from '../../../state/context'
import { toast } from 'react-toastify'
import { FaTimesCircle } from 'react-icons/fa'
import { useDispatch, useSelector } from 'react-redux'

import { createRadiologyInvestigationType, updateRadiologyInvestigationType } from '../../../state/actions/pharmacist.actions'


const PharmacistAddRadiologyInvestigationTypeModal = () => {
    const dispatch = useDispatch()

    const { modals, setModals } = useStateContext()
    const { laboratory_data } = useSelector(state => state.pharmacist)

    const [formData, setFormData] = useState({
        id: '',
        title: '',
        investigation_category: '',
    })

    useEffect(() => {
        setFormData({
            ...formData,
            id: laboratory_data?.id,
            title: laboratory_data?.title,
            investigation_category: laboratory_data?.investigation_category
        })
    }, [laboratory_data])

    const handleChange = (e, name) => {
        setFormData((prevState) => ({ ...prevState, [name]: e.target.value }))
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        if (!formData.title) return toast.warning('All fields are required!')
        dispatch(createRadiologyInvestigationType({ formData, toast, setModals, modals }))
    }

    const handleUpdate = (e) => {
        e.preventDefault()
        if (!formData.title) return toast.warning('All fields are required!')
        dispatch(updateRadiologyInvestigationType({ formData, toast, modals, setModals }))
    }

    return (
        <div>
            <div className='absolute grid h-screen w-full z-20 bg-[#11111180] place-items-center'>
                <div className='bg-white rounded px-[30px] py-[20px] w-[600px]'>
                    <div className='flex flex-col space-y-5'>
                        <div className='flex justify-between items-center'>
                            <h4 className={`${modals.showPharmacistAddRadiologyInvestigationTypeModal ? 'text-dark-green' : 'text-sky-600'} text-[16px] font-medium`}>
                                {modals.showPharmacistAddRadiologyInvestigationTypeModal ? 'Add Investigation Type' : 'Update Investigation Type'}
                            </h4>

                            <FaTimesCircle
                                size={20}
                                className='text-dark-yellow cursor-pointer'
                                showUpdateRadiologyInvestigationTypeModal
                                onClick={() => {
                                    modals.showPharmacistAddRadiologyInvestigationTypeModal && setModals({ ...modals, showPharmacistAddRadiologyInvestigationTypeModal: !modals.showPharmacistAddRadiologyInvestigationTypeModal })
                                    modals.showPharmacistUpdateRadiologyInvestigationTypeModal && setModals({ ...modals, showPharmacistUpdateRadiologyInvestigationTypeModal: !modals.showPharmacistUpdateRadiologyInvestigationTypeModal })
                                }}
                            />
                        </div>

                        {modals.showPharmacistAddRadiologyInvestigationTypeModal && (
                            <form onSubmit={handleSubmit} >
                                <div className='flex'>
                                    <input
                                        type='text'
                                        name='title'
                                        placeholder='Name'
                                        className='border rounded w-full h-5 px-4 py-5 mt-2 hover:outline-none focus:outline-none focus:ring-blue-500 focus:ring-blue 5ounded'
                                        onChange={(e) => handleChange(e, e.target.name)}
                                    />
                                </div>

                                <div className='mt-4 flex justify-center items-center'>
                                    <button
                                        type='submit'
                                        className='inline-block w-[175px] px-6 py-2.5 bg-dark-green text-white font-medium text-xs leading-tight rounded shadow-md hover:scale-90 transition duration-500 ease'
                                    >
                                        Submit
                                    </button>
                                </div>
                            </form>
                        )}

                        {modals.showPharmacistUpdateRadiologyInvestigationTypeModal && (
                            <form onSubmit={handleUpdate} >
                                <div className='flex'>
                                    <input
                                        type='text'
                                        name='title'
                                        placeholder='Name'
                                        value={formData.title}
                                        className='border rounded w-full h-5 px-4 py-5 mt-2 hover:outline-none focus:outline-none focus:ring-blue-500 focus:ring-blue 5ounded'
                                        onChange={(e) => handleChange(e, e.target.name)}
                                    />
                                </div>

                                <div className='mt-4 flex justify-center items-center'>
                                    <button
                                        type='submit'
                                        className='inline-block w-[175px] px-6 py-2.5 bg-sky-600 text-white font-medium text-xs leading-tight rounded shadow-md hover:scale-90 transition duration-500 ease'
                                    >
                                        Submit
                                    </button>
                                </div>
                            </form>
                        )}
                    </div>
                </div>

            </div>
        </div>
    )
}

export default PharmacistAddRadiologyInvestigationTypeModal